<!--
  Program: Side menu
  Author: SDL
  Brief: side menu common layout
-->
<template>
  <nav class="lnb_container">
    <a
      v-show="rootMenu.menuId"
      :class="isFoldMenu ? 'ico_collapsed_right' : 'ico_collapsed'"
      href="javascript:"
      @click="toggleIsFoldMenu()"
      data-trigger-resize=""
      data-toggle-state="ui---lnb-collapsed"
      :title="isFoldMenu ? $t('cop.common.main-side.expand') : $t('cop.common.main-side.fold')"
    >
    </a>
    <div class="ui--lnb-inner">
      <div class="ui--nav-heading">{{ getLabel(rootMenu) }}</div>
      <nav class="ui--sidebar">
        <!-- Level2 -->
        <ul class="ui--sidebar-nav">
          <li v-for="menu in groupMenus" :key="menu.menuId" :class="{ active: selGroupId === menu.menuId }">
            <strong>
              <a href="javascript:" v-if="menu.externalUrlUsed === true" @click="openExternalUrl(menu.externalUrl)">
                <span>{{ getLabel(menu) }}</span>
              </a>
              <a href="javascript:" v-else-if="menu.defaultPage" @click="moveMenu(menu.defaultPage.pagePath)">
                <span>{{ getLabel(menu) }}</span>
              </a>
              <a href="javascript:" v-else @click="groupSelect(menu)">
                <span>{{ getLabel(menu) }}</span>
              </a>
              <button
                class="btn ui--btn-sidebar"
                @click="groupSelect(menu)"
                v-if="getSubMenus(menu.menuId).length !== 0"
                :title="selGroupId === menu.menuId ? $t('cop.common.main-side.fold') : $t('cop.common.main-side.expand')"
              >
                <em
                  :class="{
                    'icon-arrow-up': selGroupId === menu.menuId,
                    'icon-arrow-down': selGroupId !== menu.menuId,
                  }"
                ></em>
              </button>
            </strong>
            <!-- Level3 -->
            <ul class="colapse ui--sidebar-nav ui--sidebar-subnav" :class="{ show: selGroupId === menu.menuId }" v-if="getSubMenus(menu.menuId).length !== 0">
              <li
                v-for="subMenu in getSubMenus(menu.menuId)"
                :key="subMenu.menuId"
                :class="{ active: selMenuId === subMenu.menuId }"
                @click="
                  subMenu.externalUrlUsed === true ? openExternalUrl(subMenu.externalUrl) : moveMenu(subMenu.menuUrl)
                "
              >
                <a href="javascript:">
                  {{ getLabel(subMenu) }}
                  <i v-if="subMenu.externalUrlUsed === true" class="material-icons ui--menu-icon-3">open_in_new</i></a
                >
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <div class="download_wrap">
        <template v-if="downloadMenu === 'RESOURCE'">
          <button
            :class="'btn btn_client_download ' + (downloadFlag ? 'on' : '')"
            type="button"
            @click="downloadFlag = !downloadFlag"
          >
            Web Client Download
          </button>
          <div class="download_list" v-show="downloadFlag">
            <button class="btn btn_down_linked window" type="button" @click="webClientDownload('WINDOWS')">Windows</button>
            <button class="btn btn_down_linked linux" type="button" @click="webClientDownload('LINUX')">Linux</button>
            <button class="btn btn_down_linked macos" type="button" @click="webClientDownload('MACOS')">Mac OS</button>
          </div>
        </template>
        <!-- web client -->
        <template v-else-if="downloadMenu === 'CONSOLE'">
          <button
            :class="'btn btn_client_download bg_none ' + (downloadFlag ? 'on' : '')"
            type="button"
            @click="downloadFlag = !downloadFlag"
          >
            {{ $t('cop.home.label.mycsp.cspLogin') }}
          </button>
          <div class="download_list" v-show="downloadFlag">
            <button class="btn btn_down_linked aws" type="button" @click="downloadAWSCLIScript()">{{ $t('cop.coa.cli.label.downloadAWSCLIScript') }}</button>
            <button class="btn btn_down_linked aws" type="button" @click="downloadAWSChinaCLIScript()">{{ $t('cop.coa.cli.label.downloadAWSChinaCLIScript') }}</button>
            <button class="btn btn_down_linked spc" type="button" @click="downloadSPCCLIScript()">{{ $t('cop.coa.cli.label.downloadSPCCLIScript') }}</button>
            <hr />
            <button class="btn btn_down_linked aws" type="button" @click="insertCoaLog('AWS'); openCloudUrl('aws')">{{ $t('cop.home.label.mycsp.awsConsole') }}</button>
            <button v-if="showDefaultRole" class="btn btn_down_linked aws" type="button" @click="defaultAWSPopup('aws')">{{ $t('cop.home.label.mycsp.awsDefaultRole') }}</button>
            <hr />
            <button class="btn btn_down_linked azure" type="button" @click="insertCoaLog('Azure'); openCloudUrl('azure')">{{ $t('cop.home.label.mycsp.azureConsole') }}</button>
            <!-- <button class="btn btn_down_linked azure" type="button">Azure Default Role</button>
            <hr /> -->

            <button class="btn btn_down_linked gcp" type="button" @click="insertCoaLog('GCP'); openCloudUrl('gcp')">{{ $t('cop.home.label.mycsp.gcpConsole') }}</button>
            <!-- <button class="btn btn_down_linked gcp" type="button">GCP Default Role</button> -->
            <button class="btn btn_down_linked oci" type="button" @click="insertCoaLog('OCI'); openCloudUrl('oci')">{{ $t('cop.home.label.mycsp.ociConsole') }}</button>

            <button type="button" class="btn btn_down_linked ncp" @click="ncpPopup()">Naver Console</button>

            <button type="button" class="btn btn_down_linked ali" @click="insertCoaLog('ALI'); openCloudUrl('ali')">{{ $t('cop.home.label.mycsp.aliConsole') }}</button>
            <button type="button" class="btn btn_down_linked ali" @click="insertCoaLog('ALI_CN'); openCloudUrl('ali_cn')">{{ $t('cop.home.label.mycsp.alicnConsole') }}</button>

            <button type="button" class="btn btn_down_linked scp" @click="insertCoaLog('SCP'); openCloudUrl('scp')">{{ $t('cop.home.label.mycsp.scpConsoleV1') }}</button>

            <button type="button" class="btn btn_down_linked aws" @click="insertCoaLog('AWS_CN'); openCloudUrl('aws_cn')">{{ $t('cop.home.label.mycsp.awscnConsole') }}</button>
            <button v-if="showDefaultRole" class="btn btn_down_linked aws" type="button" @click="defaultAWSPopup('aws_cn')">{{ $t('cop.home.label.mycsp.awscnDefaultRole') }}</button>
            <button type="button" class="btn btn_down_linked spc" @click="insertCoaLog('SPC'); openCloudUrl('spc')">{{ $t('cop.home.label.mycsp.spcConsole') }}</button>
            <button class="btn btn_down_linked azure" type="button" @click="insertCoaLog('Azure_China'); openCloudUrl('azure_cn')">{{ $t('cop.home.label.mycsp.azureCnConsole') }}</button>
            <button class="btn btn_down_linked castAi" type="button" @click="insertCoaLog('CAST_AI'); openCloudUrl('cast_ai')">{{ $t('cop.home.label.mycsp.castAiConsole') }}</button>
            <!--
            <button type="button" class="btn btn_down_linked oci" @click="onCspLoginClick(cspLinks['oci'], true)">Oracle Console</button>
            <button type="button" class="btn btn_down_linked ncp" @click="onCspLoginClick(cspLinks['ncp'], true)">Naver Console</button>
            <button type="button" class="btn btn_down_linked ali" @click="onCspLoginClick(cspLinks['ali'], true)">Alibaba Console</button>
            <button type="button" class="btn btn_down_linked scp" @click="onCspLoginClick(cspLinks['scp'], true)">Samsung Console</button>
            -->
          </div>
        </template>
        <!-- //web client -->
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, RequestUtil } from '@/utils';
// import RemCommon from '../../../../mixin/RemCommon'
import RemCommon from '@/mixin/RemCommon';
import RouterCommon from '@/mixin/RouterCommon';
import AwsDefaultRole from '@/components/view/admin/main/AwsDefaultRolePopup.vue';
import NcpRolePopup from '@/components/view/admin/main/NcpRolePopup.vue';

export default {
  name: 'SideMenu',
  mixins: [SDLLocale, RemCommon, RouterCommon],
  data() {
    return {
      rootMenu: {},
      groupMenus: [],
      selGroupId: '',
      selMenuId: '',
      downloadFlag: false,
      rootMenuCode: SDLUtil.getCommCodeList({ commCodeTypeId: 'SIDE_DOWNLOAD_MENUID' }),
      keycloakUrl: process.env.KEYCLOAK_URL,
    };
  },
  computed: {
    ...mapGetters({
      menus: 'getMenus', // Receive menus with getter
      userDivisionInfo: 'getUserDivisionInfo',
      isFoldMenu: 'getIsFoldMenu',
    }),
    downloadMenu() {
      return _.find(this.rootMenuCode, { code: this.rootMenu.menuId })
        ? _.find(this.rootMenuCode, { code: this.rootMenu.menuId }).label
        : '';
    },
    showDefaultRole() {
      // X-131 is Visual Display Business
      // X-132 is Digital Appliances Business
      if (this.userDivisionInfo)
        return ([ 'X-131' ].includes(this.userDivisionInfo.divisionCode) || [ 'X-132' ].includes(this.userDivisionInfo.divisionCode));
      else
        return false;
    },
  },
  watch: {
    isFoldMenu(value) {
      this.$emit('fold-event', value);
      this.commitIsFoldMenu(value);
    },
    $route() {
      this.selMenuId = this.$route.meta.menuId;
      this.init();
    },
  },
  methods: {
    init() {
      const curMenu = this.getCurrentMenu();
      if (curMenu) {
        let list = [curMenu];
        for (let i = curMenu.menuLevel - 1; i > 0; i -= 1) {
          const parentMenu = this.getParentMenu(list[0].parentId);
          if (parentMenu) {
            list = [parentMenu, ...list];
          }
        }
        this.rootMenu = this.menus.find(menu => menu.menuLevel === 1 && menu.menuId === list[0].menuId);
        this.groupMenus = this.menus.filter(menu => menu.menuLevel === 2 && menu.parentId === this.rootMenu.menuId);
        // 순서 정렬
        this.groupMenus = _.sortBy(this.groupMenus, ['menuSequence']);
        this.selGroupId = list[1] ? list[1].menuId || '' : '';
        this.selMenuId = _.last(list).menuId;
      } else {
        this.rootMenu = {};
      }
    },
    moveMenu(pagePath) {
      // 메뉴에서 강제로 이동시에는 저장된 파라미터 초기화
      // Initialize saved parameters when forced to move from the menu
      // Initialize stored parameters when forced to move from menu
      store.commit('PARAMS', {});
      this.handleRouterPush(pagePath);
      // If the moving component is the same, refresh is required
      if (this.isOpenNewTab) return;
      const fromComponentName = this.$route.meta.componentName;
      const toMenu = _.find(this.menus, ['menuUrl', pagePath]);
      if (toMenu.menuLevel === 2) this.selGroupId = toMenu.menuId;
      if (toMenu.menuLevel === 3) this.selMenuId = toMenu.menuId;
      if (fromComponentName === toMenu.componentName) {
        this.$emit('router-reload');
      }
    },
    getCurrentMenu() {
      const { menuId } = this.$route.meta;
      if (menuId) return this.menus.find(item => item.menuId === menuId);
      return this.menus.find(item => item.label === 'Access Key Summary');
    },
    getParentMenu(parentId) {
      return this.menus.find(item => item.menuId === parentId);
    },
    getSubMenus(parentId) {
      return _.sortBy(this.menus.filter(menu => menu.parentId === parentId), ['menuSequence']);
    },
    groupSelect(menu) {
      if (_.find(this.menus, ['parentId', menu.menuId])) {
        this.selGroupId = this.selGroupId === menu.menuId ? '' : menu.menuId;
      } else {
        this.handleRouterPush(menu.menuUrl);
      }
    },
    openExternalUrl(url) {
      window.open(url.startsWith('http') ? url : `http://${url}`, '_blank');
    },
    openCloudUrl(cloud) {
      const cloudLinks = {
        'aws': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('AWS_KEYCLOCK')}`,
        'azure': `${SDLUtil.getExternalUrl('AZURE')}`,
        'azure_cn': `${SDLUtil.getExternalUrl('AZURE_CN')}`,
        'gcp': `${SDLUtil.getExternalUrl('GCP')}`,
        'oci': `${SDLUtil.getExternalUrl('OCI')}`,
        'ncp': `${SDLUtil.getExternalUrl('NCP')}`,
        'ali': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('ALI_KEYCLOAK_REALMS')}`,
        'ali_cn': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('ALI_CN_KEYCLOAK_REALMS')}`,
        'scp': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('SCP_KEYCLOAK_REALMS')}`,
        'aws_cn': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('AWS_CN_KEYCLOAK_REALMS')}`,
        'spc': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('SPC_KEYCLOAK_REALMS')}`,
        'cast_ai': `${SDLUtil.getExternalUrl('CAST_AI')}`,
      };
      const url = cloudLinks[cloud];
      window.open(url.startsWith('http') ? url : `http://${url}`, '_blank');
    },
    commitIsFoldMenu(value) {
      this.$store.commit('SET_IS_FOLD_MENU', value);
    },
    webClientDownload(osType) {
      const GET_WEB_CLIENT_ACTIVE_VERSION = '/api/v1/portal/webclient/GetWebClientActiveVersion';
      this.fetchGetToGoLangServer(
        GET_WEB_CLIENT_ACTIVE_VERSION,
        {},
        res => {
          let iamClient = res.data.rsp.iamclient;
          let downloadUrl = '';
          console.log('>> getDownloadURL OK');
          if(osType === 'WINDOWS') downloadUrl = iamClient[0].WIN_INSTLR_UNVRSL_DWLD_URL_ADDR;
          if(osType === 'LINUX') downloadUrl = iamClient[0].LINUX_INSTLR_UNVRSL_DWLD_URL_ADDR;
          if(osType === 'MACOS') downloadUrl = iamClient[0].MACOS_INSTLR_UNVRSL_DWLD_URL_ADDR;

          window.open(downloadUrl, '_self');
        },
        err => {
          SDLUtil.errorAlert(err);
        }
      )
    },
    defaultAWSPopup(csp) {
      SDLUtil.show(
        AwsDefaultRole,
        {
          csp: csp || 'aws',
          // 팝업에 넘기는 파라미터
          // props: propsSample,
          rtnFunc: () => {
            this.insertCoaLog('AWS_Default');
          },
        },
        {
          // 가로사이즈 : big, large, medium, small, mini
          // 세로사이즈고정 : h_fix
          sizeClass: 'small',
        },
      );
    },
    ncpPopup() {
      SDLUtil.show(
        NcpRolePopup,
        {
          rtnFunc: () => {
            this.insertCoaLog('NCP');
          },
        },
        {
          sizeClass: 'small',
        },
      );
    },
    downloadAWSCLIScript() {
      SDLUtil.confirm({
        msg: 'cop.coa.cli.message.downloadAWSCLIScript',
        title: 'sdl.common.label.download',
        okLabel: 'sdl.common.label.download',
        cancelLabel: 'sdl.common.label.cancel',
        onOkEvt: () => {
          const url = `${window.location.origin}/static/scripts/scop2aws.py`
          const a = document.createElement('A');
          a.href = url
          a.download = url.substr(url.lastIndexOf('/') + 1)
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        },
      });
    },
    downloadAWSChinaCLIScript() {
      SDLUtil.confirm({
        msg: 'cop.coa.cli.message.downloadAWSChinaCLIScript',
        title: 'sdl.common.label.download',
        okLabel: 'sdl.common.label.download',
        cancelLabel: 'sdl.common.label.cancel',
        onOkEvt: () => {
          const url = `${window.location.origin}/static/scripts/scop2awschina.py`
          const a = document.createElement('A');
          a.href = url
          a.download = url.substr(url.lastIndexOf('/') + 1)
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        },
      });
    },
    downloadSPCCLIScript() {
      SDLUtil.confirm({
        msg: 'cop.coa.cli.message.downloadSPCCLIScript',
        title: 'sdl.common.label.download',
        okLabel: 'sdl.common.label.download',
        cancelLabel: 'sdl.common.label.cancel',
        onOkEvt: () => {
          const url = `${window.location.origin}/static/scripts/scop2spc.py`
          const a = document.createElement('A');
          a.href = url
          a.download = url.substr(url.lastIndexOf('/') + 1)
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        },
      });
    },
    insertCoaLog(cspType) {
      this.$store.dispatch('INSERT_COA_LOG', cspType);
    },
    toggleIsFoldMenu() {
      this.commitIsFoldMenu(!this.isFoldMenu);
    }
  },

  created() {
    this.init();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainSideMenu.vue